/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AppStoreButton from '../../UI/AppStoreButtons/AppStoreButton';
import ShowMoreText from './ShowMoreText/ShowMoreText';
import { parseLocationToPath } from '../../../utils';
import classes from './GeneralSection.module.css';
import googleAnalytics from '../../../utils/googleAnalytics';

const GeneralSection = ({ section, onBackToTop }) => {
  const { contents } = section;
  const location = useLocation();
  const currentPath = parseLocationToPath(location);
  const hub = useSelector((state) => state.hub.hub);

  useEffect(() => {
    if (currentPath.search('home') === -1) {
      onBackToTop();
    }
  }, [currentPath, onBackToTop]);
  const [{ Src, thumbnail, media, storeButtons, button, description }] =
    contents;
  let link;
  if (media === null && Src === null) {
    link = '#';
    if (button !== null && button?.buttonAtImage) link = button.link;
  } else if (media !== null) {
    link = media.url;
  } else {
    link = Src.link;
  }

  return (
    <div id="aa" className={classes.container}>
      {link === '#' ? (
        <img alt="main" className={classes.mainImage} src={thumbnail[0].url} />
      ) : (
        <a
          target="_blank"
          href={link}
          rel="noreferrer"
          onClick={() => {
            googleAnalytics({
              event: 'outboundLink',
              link_url: link,
              link_title: link,
              section_title: hub.name,
            });
          }}
        >
          <img
            alt="main"
            className={classes.mainImage}
            src={thumbnail[0].url}
          />
        </a>
      )}

      <ShowMoreText>{description}</ShowMoreText>
      {storeButtons !== null && <AppStoreButton links={storeButtons} />}
      {button !== null && (
        <a
          href={button.link}
          className={classes.buttonAction}
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            googleAnalytics({
              event: 'outboundLink',
              link_url: button.link,
              link_title: button.label,
              section_title: hub.name,
            });
          }}
        >
          {button.label}
        </a>
      )}
    </div>
  );
};

GeneralSection.propTypes = {
  section: PropTypes.shape({
    contents: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        imageSrc: PropTypes.string,
        button: PropTypes.shape({
          label: PropTypes.string,
          link: PropTypes.string,
        }),
        storeButtons: PropTypes.shape({}),
      })
    ),
  }).isRequired,
  onBackToTop: PropTypes.func,
};
GeneralSection.defaultProps = {
  onBackToTop: () => {},
};

export default GeneralSection;
